<template>
  <div class="w-full h-full">
    <div class="relative flex flex-col h-full">
      <app-tabs-page class="my-auto" #default="slotProps">
        <router-view #default="{Component}">
          <transition @enter="scrollTop" name="fade" mode="out-in">
            <component :is="Component" :navigate="slotProps.navigate" />
          </transition>
        </router-view>
      </app-tabs-page>
      <app-cta-button
        cta
        mobile-only
        full-width
        :link="apriContoUrl"
        external
      />
    </div>
    <!-- <div class="parallax absolute inset-0 flex items-center justify-center">
      <img class="max-h-96 " src="/img/bubble.png" />
    </div> -->
  </div>
</template>

<route>
{
  "name": "Insieme per l\\'ambiente",
  "redirect": { 
      "name": "Mediterraneo a rischio"
  },
  "meta": {
      "order": 9,
      "label": "Insieme per l'ambiente",
      "directLink": true,
      "hideMenu": {
        "inline": true
      }  }
}
</route>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
